/**
 * Slider default a11y values from page translations
 * 
 * @returns {object}
 */
export const a11y = () => {
  return {
    nextSlideMessage: Settings.slider.i18n.btn_next,
    prevSlideMessage: Settings.slider.i18n.btn_prev,
    firstSlideMessage: Settings.slider.i18n.first_slide_msg || '',
    lastSlideMessage: Settings.slider.i18n.last_slide_msg || '',
    paginationBulletMessage: Settings.slider.i18n.pagination_msg || '',
    slideLabelMessage: Settings.slider.i18n.slide_label_msg || '{{index}} / {{slidesLength}}',
  }
};

/**
 * Get Swiper slider slide index by data-attribute on .swiper-slide element
 * 
 * @param {Swiper} slider - Swiper slider instance
 * @param {string} value - data-attribute value
 * @param {object} options - Optional settings
 * @param {string} [options.attribute=data-packing] - data-attribute name
 * 
 * @returns {null|number}
 */
export const getSlideIndexByAttr = (slider, value, options = {}) => {
  const _defaults = {
    attribute: 'data-packing',
  };
  const opts = { ..._defaults, ...options };
  let result = null;
  Array.from(slider.slides).forEach((slideEl, i) => {
    if (
      typeof result !== 'number' && 
      slideEl.hasAttribute(opts.attribute) &&
      slideEl.getAttribute(opts.attribute) === value
    ) {
      result = i;
    }
  });
  return result;
};
